module.exports = __webpack_public_path__ + "img/size2_en.1d2ef748.png";